import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common'
import { ActivatedRoute, Params } from '@angular/router';
import { Store } from '@ngrx/store';
import { GalleryComponent, GalleryState, ImageItem } from 'ng-gallery';
import { deserializeDetailsParams } from 'src/app/actions';
import { Acabado, DetalleStock, Disponibilidad, getUnidadMedida, Maestros, Material, UnidadMedida } from 'src/app/models';
import { MaterialesService } from 'src/app/services';
import * as fromSelectors from '../../selectors';
import { translatePos } from '../../components/image-viewer/image-viewer.component';
import { getLanguage, getLanguageFromUrl, Language } from 'src/app/language';
import { ModuleState } from 'src/app/state';
import { PinchZoomComponent } from 'ngx-pinch-zoom';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'expand-modal',
  templateUrl: './expand-modal.container.html',
  styleUrls: ['./expand-modal.container.css']
})
export class ExpandModalContainer implements OnInit {
  detalles: DetalleStock[] = [];
  imgs: ImageItem[] = [];
  maestros: Maestros;
  zoom: number = 1;
  isZoom: boolean = false;
  zoomMousePositionX: number = 0;
  zoomMousePositionY: number = 0;
  zoomMouseDown: boolean = false;
  zoomElement: HTMLElement;
  currentDetalleIndex: number = 0;
  language: Language;
  unidadMedida: UnidadMedida;
  allowGesture: boolean = true;
  query: Params;  
  groupByBundle: boolean = false;

  get currentDetalle(): DetalleStock {
    return this.detalles[this.currentDetalleIndex || 0];
  }
  @ViewChild(PinchZoomComponent) zoomComponent;
  @ViewChild(GalleryComponent) galleryComponent: GalleryComponent;

  // @ViewChild(ImageViewerComponent) viewer: ImageViewerComponent;

  constructor(
    private route: ActivatedRoute,
    private store: Store,
    private location: Location,
    private materialesService: MaterialesService) {}

  getNombreMaterial(codigo: Material['CODIGO']): string {
    return this.materialesService.getNombreMaterial(codigo, this.maestros);
  }

  getNombreTipoMaterial(id: Material['TIPOMATERIALID']): string {
    return this.materialesService.getNombreTipoMaterial(id, this.maestros);
  }

  getAcabadoMaterial(codigo: Acabado['CODIGO']): string {
    return this.materialesService.getAcabadoMaterial(codigo, this.maestros);
  }

  getAncho(val: string): string {
    return this.materialesService.getAncho(val)
  }

  getDisponibilidad(codigo: Disponibilidad['CODIGO']): string {
    return this.materialesService.getDiponibilidad(codigo, this.maestros);
  }

  getColorMaterial(codigo: Material['CODIGO']): string {
    return this.materialesService.getColorMaterial(codigo, this.maestros);
  }

  getUnidadLanguage(): string {
    return this.unidadMedida === UnidadMedida.CM ? 'cm' : getLanguage(getLanguageFromUrl()).PULGADAS
  }

  getMedida(medida: string): string {
    return getUnidadMedida(this.unidadMedida, parseFloat(medida)) + ' ';
  }
  
  getEspesor(medida: string): string {
    return parseFloat(medida) + ' cm';
  }

  getPiezas(piezas: string) {
    return parseFloat(piezas);
  }

  getDownloadPath(path: string) {
    return environment.downloadBase + path;
  }

  galleryIndexChange(change: GalleryState) {
    translatePos.x = 0;
    this.zoom = 1;
    translatePos.y = 0;
    this.currentDetalleIndex = change.currIndex;
  }

  zoomIn(): void {
    if(!this.isZoom){
      this.zoomComponent.toggleZoom();
      this.isZoom = true;
    }
  }

  zoomOut(): void {
    if(!!this.isZoom){
      this.zoomComponent.toggleZoom();
      this.isZoom = false;
    }
  }

  mousewheel(evt:MouseWheelEvent) {
    const el: HTMLElement = document.querySelector('.zoom');
    if(evt.deltaY < 0){
      this.zoomIn();

    } else {
      this.zoomOut();
    }
  }

  setZoomCenterPosition(): void {
    translatePos.x = 0;
    translatePos.y = 0;
  }

  back(): void {
    //console.log(this.location.getState())
    this.location.back();
  }

  tgglGesture() {
    this.galleryComponent.gestures = this.zoomComponent.isZoomedIn ? false : true;
  }

  ngOnInit(): void {

    this.groupByBundle = environment.byBundle;
    
    this.store.select(fromSelectors.selectDetalles).subscribe(detalles =>{
      if(this.query){
        this.detalles = [...detalles]
        this.imgs = this.detalles.map(d => new ImageItem({ src: d.IMAGENMINIURL, thumb: d.IMAGENMINIURL }));
        this.currentDetalleIndex = parseInt(this.query.index);
        setTimeout(() => {
          this.galleryComponent.set(parseInt(this.query.index));
        }, 100)
      }
    });

    this.route.queryParams.subscribe(query => {
      this.query = query;
      this.store.dispatch(deserializeDetailsParams({ query: 
        environment.byBundle 
        ?
        {
          bloque: query.bloque,
          material: query.material,
          acabado: query.acabado,
          ancho: query.ancho,
          //grupo: query.grupo
        } 
        : 
        {
          bloque: query.bloque,
          material: query.material,
          acabado: query.acabado,
          ancho: query.ancho
        }
      }));
    })

    // Debería normalizarse dentro del estado
    this.store.select(fromSelectors.tipoMaterialSelector).subscribe(tipoMaterial => this.maestros = { ...this.maestros, tipoMaterial });
    this.store.select(fromSelectors.acabadoSelector).subscribe(acabado => this.maestros = { ...this.maestros, acabado });
    this.store.select(fromSelectors.usoMaterialSelector).subscribe(usoMaterial => this.maestros = { ...this.maestros, usoMaterial });
    this.store.select(fromSelectors.continenteSelector).subscribe(continente => this.maestros = { ...this.maestros, continente });
    this.store.select(fromSelectors.colorMaterialSelector).subscribe(colores => this.maestros = { ...this.maestros, colorMaterial: colores });
    this.store.select(fromSelectors.espesorSelector).subscribe(espesor => this.maestros = { ...this.maestros, espesor });
    this.store.select(fromSelectors.disponibilidadSelector).subscribe(disponibilidad => this.maestros = { ...this.maestros, disponibilidad });
    this.store.select(fromSelectors.rangoPrecioSelector).subscribe(rangoPrecio => this.maestros = { ...this.maestros, rangoPrecio });
    this.store.select(fromSelectors.materialesSelector).subscribe(materiales => this.maestros = { ...this.maestros, materiales });

    this.store.select((state: ModuleState) => state.unidadMedida).subscribe(unidad => this.unidadMedida = unidad)

    this.language = getLanguage(getLanguageFromUrl());
  }

}
